import { Component, HostListener, OnInit } from '@angular/core';
import { FormGroup, FormControl, FormArray, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { User} from 'src/app/Model/User/user.model';
import { UserRole } from 'src/app/Model/Role/user-role.model'
import { AuthenticationService } from 'src/app/Services/Authentication/authentication.service';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-chat',
  templateUrl: './chat.component.html',
  styleUrls: ['./chat.component.css']
})
export class ChatComponent implements OnInit {
  @HostListener('window:message',['$event'])
  onMessage(e)
  {
    let d,p,c,totalunread = 0;
    //console.log(e);
    var i =e.data;
    const myJSON = JSON.stringify(i);
    var j = JSON.parse(myJSON);
  //  console.log(j);
    
    if(j.eventName == "unread-changed"){
             
      if(isNaN(totalunread) || totalunread == j.data){
                       console.log("No New Message");

      }
  
else{
   totalunread =  j.data;
               console.log("Total Unread Messages: " + totalunread );
console.log("Total Direct Messages: " + d);
console.log("Total Team Messages: " + p);
console.log("Total Channel Messages: " + c);

      p=0;
      d=0;
      c=0;
   
  }
  
  }
    
  if (e.origin!="http://localhost:4200")
    {
    return false;
    }
  if (e.data.for=="user")
    {
    alert('here i am');
    }
  }
  link;
  iframeSrc: SafeUrl;
  chatLoginForm:FormGroup;
  currentUser:User;
  username;
  branch;
  role;

  loggedInFirstName;
  loggedInMiddleName;
  loggedInLastName;
  loggedInUsername;
  loggedInEmail;
  loggedInRole;
  loggedInUserBranch;
  loggedInUserFullname;
  loggedInUserId;
  loggedInEncryptPassword;

  totalunread;
  
  constructor( private fb: FormBuilder,
    private sanitizer: DomSanitizer,
              private _authenticationService: AuthenticationService) { 

    this._authenticationService.currentUser.subscribe(x => this.currentUser = x);
    if(this.currentUser){
      
      this.username=this.currentUser.firstName+' '+this.currentUser.middleName+' '+this.currentUser.lastName;
      this.branch=this.currentUser.branch;
      this.role=this.currentUser.role;


      this.loggedInFirstName=this.currentUser.firstName;
      this.loggedInMiddleName=this.currentUser.middleName;
      this.loggedInLastName=this.currentUser.lastName;
      this.loggedInUsername=this.currentUser.userName;
      this.loggedInUserFullname= this.username;
      this.loggedInEmail=this.currentUser.email;
      this.loggedInRole=this.currentUser.role;
      this.loggedInUserBranch= this.branch
      this.loggedInUserId=this.currentUser.userName;
      this.loggedInEncryptPassword=this.currentUser.encryptedPassword;
  if(this.loggedInUserId!='' || this.loggedInUserId!=null){
      //console.log(this.loggedInEncryptPassword);
  //this.link=`https://ciotchat.dart-it.com/ilogin/?username=${this.loggedInUserId}&password=${this.loggedInEncryptPassword}`;
  //this.iframeSrc = this.sanitizer.bypassSecurityTrustResourceUrl(this.link);
  }
     }
     console.log(this.link);
  }

  ngOnInit(): void {

    this.chatLoginForm = this.fb.group({
      //actionPerformedBy:new FormControl(this._authenticationService.currentUserValue.userName),
      firstName: new FormControl(this.loggedInFirstName),
      middleName: new FormControl(this.loggedInMiddleName),
      lastName: new FormControl(this.loggedInLastName),
      email: new FormControl(this.loggedInEmail),
      userName: new FormControl(this.loggedInUserId),
      branch: new FormControl(this.loggedInUserBranch),
      role: new FormControl(this.loggedInRole),
      encryptedPassword:new FormControl(this.loggedInEncryptPassword),
   
  });


  var iframe = document.getElementById('IFrame') as HTMLIFrameElement;
  console.log(iframe);
  iframe.addEventListener('message', function(event) {
  //console.log(event.data);
  //var i =event.data
  //const myJSON = JSON.stringify(i);
  //var j = JSON.parse(myJSON);
  //var totalunread = j
  //console.log(j.eventName);
   //console.log(j);
  
  
  /**if(j.eventName == "unread-changed"){
      
      if(isNaN(totalunread) || totalunread == j.data){
                       console.log("No New Message");

      }
  
else{
  this.totalunread =  j.data;
               console.log("Total Unread Messages: " + totalunread );
console.log("Total Direct Messages: " + d);
console.log("Total Team Messages: " + p);
console.log("Total Channel Messages: " + c);

      p=0;
      d=0;
      c=0;
   
  }
  
  }**/
//console.log("Message received  from application: " + myJSON);
// Message received from parent
});

}//End Of ngOnInit




}
